import messages from './inscripcio-modal-translations';
import * as $ from 'jquery';

export default {
    name: 'instamapsInscripcioModal',
    data() {
        return {
            submitSuccess: false,
            submitError: false,
        };
    },
    i18n: {
        messages,
    },
    props: {
        delay: { type: Number },
    },
    methods: {
        show: function () {
            setTimeout(function () {
                $('#inscripcio-modal').addClass('animate-flex-modal');
            }, (this.delay) ? this.delay : 100);
        },
        dismiss: function () {
            $('#inscripcio-modal').removeClass('animate-flex-modal');
            this.submitError = false;
            this.submitSuccess = false;
        },
    },
    mounted() {
        this.$on('showInscripcioModal', this.show());
    },
};



// WEBPACK FOOTER //
// ./src/home-geolocal/components/inscripcio-modal/inscripcio-modal.js